// extracted by mini-css-extract-plugin
module.exports = {"title":"Best_title__1ijXr","header":"Best_header__yzA9k","cardsGrid":"Best_cardsGrid__5TWOo"};